import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';

import { ErrorDialogComponent } from '../../../shared/components/error-dialog/error-dialog.component';
import { DataTypeUtils } from '../../../utils/data-type.util';
import { StringUtils } from '../../../utils/string.utils';
import { BeneficiariesService } from '../beneficiaries.service';
import { BeneficiaryHistoryResponse } from '../models/beneficiary-history-response.model';

@Component({
	selector: 'app-beneficiary-history',
	styleUrls: ['./beneficiary-history.component.scss'],
	templateUrl: './beneficiary-history.component.html',
})
export class BeneficiaryHistoryComponent implements OnInit {
	beneficiary: { name?: string; organizationName?: string } = {
		name: '',
		organizationName: '',
	};
	beneficiaryId: string = '';
	capitalize = StringUtils.capitalize;
	isLoading: boolean = false;
	nullPlaceholder: string = DataTypeUtils.string.getNullPlaceholder();
	organizationId: string = '';

	tableColumns: string[] = [
		'actionType',
		'description',
		'validityBeginning',
		'validityEnding',
		'permanencyDate',
		'responsibleUser',
		'actionDate',
	];

	tableData = new MatTableDataSource<BeneficiaryHistoryResponse>([]);

	constructor(
		private readonly location: Location,
		private readonly activatedRoute: ActivatedRoute,
		private readonly beneficiariesService: BeneficiariesService,
		public dialog: MatDialog,
	) {}

	getHistory(): void {
		this.isLoading = true;

		this.beneficiariesService.getHistory(this.beneficiaryId).subscribe(
			(log) => {
				this.tableData = new MatTableDataSource<BeneficiaryHistoryResponse>(
					log,
				);
				this.isLoading = false;
			},
			(error) => {
				this.onError(
					error.error.message ||
						'Ocorreu um erro ao tentar fazer a busca do histórico deste beneficiário',
				);
				this.isLoading = false;
			},
		);
	}

	// TODO: Refatorar para obter os dados via parâmetro de rota, quando vier da tela anterior ou buscar no banco, quando for primeira carga da tela
	initBeneficiaryData(): void {
		const locationState = this.location.getState() as {
			name: string;
			navigationId: number;
			organizationName: string;
		};

		this.beneficiary = {
			name: locationState?.name,
			organizationName: locationState?.organizationName,
		};
	}

	ngOnInit(): void {
		this.activatedRoute.params.subscribe(({ id, beneficiaryId }) => {
			this.beneficiaryId = beneficiaryId;
			this.organizationId = id;
			this.initBeneficiaryData();
			this.getHistory();
		});
	}

	onError(message: string): void {
		const dialogRef = this.dialog.open(ErrorDialogComponent, {
			data: {
				errorMessage: message,
				title: 'Ocorreu um erro ao tentar obter o Histórico de Beneficiário',
			},
			maxHeight: undefined,
			maxWidth: undefined,
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				this.getHistory();
			}
		});
	}
}
